import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_DELETE_HALAL_STOCK } from "../../../config/api";

export const deleteStock = createAsyncThunk(
  "stocks/delete",
  async ({ id, callback, navigate }, { rejectWithValue }) => {
    try {
      const response = await Client({
        method: "DELETE",
        path: API_DELETE_HALAL_STOCK(id),
      });
      toast.success("Stock deleted successfully");
      callback && callback();
      navigate && navigate("/stocks", { replace: true });
      return response?.data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      return rejectWithValue(error.message);
    }
  }
);
